<template>
  <div class="form_con">
    <top-header
      :type="6"
      :placeholder="''"
      :bgColor="'#fff'"
      fontSize="0.32rem"
    />
    <h3>变更手机号申请</h3>
    <van-form
      @submit="onSubmit"
      validate-trigger="onSubmit"
      :scroll-to-error="true"
    >
      <van-field
        v-model="userName"
        name="userName"
        label="姓名"
        placeholder="请输入姓名"
        maxlength="10"
        :rules="[
          { required: true, validator: testPerson, message: '请填写中文姓名' },
        ]"
      />
      <van-field
        v-model="cardNo"
        name="cardNo"
        label="身份证号"
        placeholder="请输入身份证号"
        maxlength="18"
        :rules="[{ validator: testIdCard, message: '请填写正确的身份证号' }]"
      />
      <van-field
        v-model="phone"
        type="tel"
        name="phone"
        label="新手机号"
        maxlength="11"
        placeholder="请输入手机号"
        :rules="[{ validator: testPhone, message: '请填写正确的手机号' }]"
      />
      <h5>上传身份证</h5>
      <div class="pic_con">
        <van-uploader :before-read="beforeRead" :after-read="afterRead">
          <img :src="img1" alt="" class="small" />
        </van-uploader>
        <p>头像面</p>
      </div>
      <div class="pic_con">
        <van-uploader :before-read="beforeRead" :after-read="afterRead1">
          <img :src="img2" alt="" class="small" />
        </van-uploader>
        <p>国徽面</p>
      </div>
      <div class="pic_con">
        <div class="m_flex_box flex_jz">
          <van-uploader :before-read="beforeRead" :after-read="afterRead2">
            <img :src="img3" alt="" class="big" />
          </van-uploader>
          <span class="col_blue" @click="show = true">查看示例</span>
        </div>
        <p>手持</p>
        <p class="example">
          手持身份证照片内身份证文字信息需清晰，拍摄手持身份证照前，需用白纸（A4纸最佳）标记如下文字并一同拍摄，文字信息为：“仅用于XXXX年XX月XX日徐州市房地产信息网用户变更手机号申请”
        </p>
      </div>
      <van-field
        class="b_f"
        v-model="code"
        name="code"
        label="验证码"
        placeholder="请输入短信验证码"
        maxlength="4"
        :rules="[{ required: true, message: '请填写验证码' }]"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            native-type="button"
            @click="sendCode"
            :disabled="codeTime < 120 ? true : false"
            >{{
              codeTime === 120 ? "发送验证码" : codeTime + "秒后重发"
            }}</van-button
          >
        </template>
      </van-field>
      <div style="margin: 16px">
        <van-button block type="info" native-type="submit"> 提交 </van-button>
      </div>
    </van-form>
    <van-overlay
      :show="show"
      class="m_flex_box flex_hc flex_vc"
      @click="show = false"
    >
      <div class="wrap m_flex_box flex_vc flex_hc">
        <img src="@/assets/img/sfz_s.jpg" alt="" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
let timmer = null;
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      show: false,
      userName: "",
      role: "",
      cardNo: "",
      phone: "",
      code: "",
      codeTime: 120,
      img1: require("@/assets/img/u1.png"),
      img2: require("@/assets/img/u2.png"),
      img3: require("@/assets/img/u3.png"),
      image1: "",
      image2: "",
      image3: "",
    };
  },
  components: {
    topHeader,
  },
  mounted() {},
  methods: {
    testPerson(data) {
      return /^[\u4E00-\u9FA5]+$/.test(data);
    },
    testPhone(data) {
      return /^1[3456789]\d{9}$/.test(data);
    },
    testIdCard(data) {
      return /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/.test(
        data
      );
    },
    sendCode() {
      if (!this.userName) {
        this.$toast("请输入姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请输入正确的身份证号");
        return;
      } else if (!this.phone) {
        this.$toast("请输入正确的手机号");
        return;
      }
      const formData = new FormData();
      formData.append("name", this.userName);
      formData.append("cardNo", this.cardNo.toUpperCase());
      formData.append("phone", this.phone);
      if (this.codeTime === 120) {
        this.$http({
          url: "cms/phoneChange/permit/getPersonCode.do",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: formData,
        }).then((res) => {
          if (res.success) {
            this.$toast("验证码发送成功，请查收");
            this.codeTime -= 1;
            let setTimer = setInterval(() => {
              if (this.codeTime > 0) {
                this.codeTime -= 1;
              } else {
                this.codeTime = 120;
                clearInterval(setTimer);
              }
            }, 1000);
          } else {
            this.$toast(res.msg);
          }
        });
      }
    },
    beforeRead(file) {
      if (
        file.type.toLowerCase() !== "image/jpg" &&
        file.type.toLowerCase() !== "image/png" &&
        file.type.toLowerCase() !== "image/jpeg" &&
        file.type.toLowerCase() !== "image/gif"
      ) {
        this.$toast("该格式不支持");
        return false;
      } else if (file.size > 10000 * 1024) {
        this.$toast("文件大小不得超过5M");
        return false;
      }
      return true;
    },
    afterRead(file) {
      this.img1 = file.content;
      this.image1 = file.file;
    },
    afterRead1(file) {
      this.img2 = file.content;
      this.image2 = file.file;
    },
    afterRead2(file) {
      this.img3 = file.content;
      this.image3 = file.file;
    },
    onSubmit(values) {
      if (!this.image1) {
        this.$toast("请上传身份证头像面");
        return;
      } else if (!this.image1) {
        this.$toast("请上传身份证国徽面");
        return;
      } else if (!this.image1) {
        this.$toast("请上传手持身份证");
        return;
      }
      const formData = new FormData();
      formData.append("name", this.userName);
      formData.append("cardNo", this.cardNo.toUpperCase());
      formData.append("code", this.code);
      formData.append("phone", this.phone);
      formData.append("sfz_z", this.image1);
      formData.append("sfz_b", this.image2);
      formData.append("sfz_s", this.image3);
      this.$http({
        url: "cms/phoneChange/permit/personAdd.do",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      })
        .then((res) => {
          if (res.success) {
            this.$dialog
              .alert({
                title: "提示",
                message: res.msg,
              })
              .then((res) => {
                this.$router.replace("/login");
              });
          } else {
            this.$dialog.alert({
              title: "提示",
              message: res.msg,
            });
          }
        })
        .catch(() => {
          this.$dialog.alert({
            title: "提示",
            message: res.msg,
          });
        });
    },
    onConfirm(value) {
      this.role = value.text;
      this.showPicker = false;
    },
  },
};
</script>
<style lang="less" scoped>
h3 {
  font-size: 0.36rem;
  font-weight: 800;
  padding: 0 16px;
  margin: 0 auto 0.6rem;
}
.form_con {
  padding: 0.3rem 0rem;
  /deep/ .b_f {
    line-height: 32px;
  }
}
h5 {
  font-size: 14px;
  padding: 10px 16px 0;
  color: #646566;
}
.pic_con {
  padding: 16px 16px;
  position: relative;
  .small {
    width: 2.56rem;
    height: 1.63rem;
  }
  .big {
    width: 2.18rem;
    height: 3.4rem;
  }
  p {
    color: #474747;
    font-size: 12px;
    width: 2.56rem;
    text-align: center;
    margin-top: 0.1rem;
    color: #666;
  }
  .example {
    width: 100%;
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
    text-align: left;
    box-sizing: border-box;
    padding: 0.2rem 0.2rem;
    font-size: 0.3rem;
  }
  &:after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}
.col_blue {
  color: #2f72f5;
  font-size: 0.26rem;
}
.wrap {
  background-color: #fff;
  width: 6rem;
  height: 5.5rem;
  border-radius: 0.02rem;
  img {
    width: 5.5rem;
    height: 4.2rem;
  }
}
</style>